module.exports = __webpack_public_path__ + "f024213c2207805b454bc6dc45e0039b.pdf";